<p-dialog
  [header]="'case.vehicle-timeline.staff-information-header' | translate"
  [(visible)]="showTeamMembers"
  [modal]="true"
  (onHide)="teamInfoClose()"
  [closable]="true"
  [style]="{ width: '40%', 'max-height': '75vh', 'overflow-y': 'auto' }"
>
  <div class="location">{{ dotName }}</div>

  <div class="team-members">
    <div class="member-card" *ngFor="let member of teamMembers">
      <div class="member-info">
        <div class="avatar">
          @if (member.photo) {
            <img [src]="member.photo" class="avatar avatar-md" alt=""/>
          } @else {
            <i class="fa fa-user"></i>
          }
        </div>
        <div class="details">
          <div class="name">{{ member?.fullname }}</div>
          <div class="role">{{ member?.watchRole }}</div>
        </div>
      </div>
      <span class="badge badge-outline-success rounded me-1"
            *ngIf="member?.isCome">{{ 'mobile-status.watch-status.come' | translate }}</span>
      <span class="badge badge-outline-danger rounded me-1"
            *ngIf="!member?.isCome">{{ 'mobile-status.watch-status.notcome' | translate }}</span>
      <app-call-button *ngIf="member?.contact?.phone" [class]="'btn btn-sm btn-success rounded'"
                       [phone]="member.contact.phone"></app-call-button>
    </div>
  </div>
</p-dialog>
